import Alpine from 'alpinejs';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { getPrecedingContentLayoutGallery } from '../MobilePhotoSwipe/AdjacentGallery';

Alpine.data('shiftimages', () => ({
    media: null,

    init() {
        if (window.innerWidth < 768) return;

        const shiftImages = this.$root;
        const leftImage = shiftImages.querySelector('.shift-images__image--left');
        const rightImage = shiftImages.querySelector('.shift-images__image--right');

        if (!leftImage || !rightImage) {
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        // Continue the odd/even motion sequence across the preceding gallery.
        const precedingGallery = getPrecedingContentLayoutGallery(shiftImages);
        const hasOddPrecedingImageCount = precedingGallery?.closest('section')?.dataset.imagesCount === 'odd';
        const leftSequenceImage = hasOddPrecedingImageCount ? rightImage : leftImage;
        const rightSequenceImage = hasOddPrecedingImageCount ? leftImage : rightImage;

        this.media = gsap.matchMedia();
        this.media.add('all', () => {
            const getDistance = () => {
                const distance = shiftImages.getBoundingClientRect().height * 0.16;

                return Math.min(Math.max(distance, 32), 120);
            };

            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: shiftImages,
                    start: 'top bottom',
                    end: 'bottom top',
                    invalidateOnRefresh: true,
                    scrub: true,
                    snap: false,
                    markers: false, //dev
                },
            });

            timeline
                .fromTo(
                    leftSequenceImage,
                    {
                        y: () => getDistance(),
                    },
                    {
                        y: () => getDistance() * -1,
                        ease: 'none',
                    },
                    0
                )
                .fromTo(
                    rightSequenceImage,
                    {
                        y: () => getDistance() * -1,
                    },
                    {
                        y: () => getDistance(),
                        ease: 'none',
                    },
                    0
                );

            return () => {
                timeline.kill();
                gsap.set([leftImage, rightImage], { clearProps: 'transform' });
            };
        });
    },

    destroy() {
        this.media?.revert();
    },
}));
